import { useCallback } from 'react';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import Button, { isButtonDisabled } from 'src/components/design-system/Button';
import PopUp from 'src/components/design-system/PopUp';
import useReceiptDetails from 'src/hooks/useReceiptDetails';
import useUnDeleteReceiptsApi from 'src/services/useUnDeleteReceiptApi';

const UnDeleteReceipt = () => {
  const { unDeleteReceipts, unDeleteReceiptLoading } = useUnDeleteReceiptsApi();
  const { receiptData, refreshPage, recId } = useReceiptDetails();

  const { unDeleteReceipt } = receiptData;

  const handleUndelete = useCallback(async () => {
    try {
      await unDeleteReceipts({ receiptIds: [recId] });
    } catch (error) {
      console.error(error);
    } finally {
      refreshPage();
    }
  }, [recId, refreshPage, unDeleteReceipts]);

  return (
    <PopUp
      content={<PopUpContentWrapper type="Error" contents={[]} />}
      show={isButtonDisabled(unDeleteReceipt)}
    >
      <Button
        onClick={handleUndelete}
        loading={unDeleteReceiptLoading}
        color="dark"
        buttonState={unDeleteReceipt}
        disabled={isButtonDisabled(unDeleteReceipt)}
      >
        Undelete
      </Button>
    </PopUp>
  );
};

export default UnDeleteReceipt;
